import { Edit, SimpleForm } from "react-admin";
import SaveForm from "./SaveForm";
import BackButtonToolbar from "features/BackButtonToolbar";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";

const EditBuilding = () => {
  return (
    <Edit
      title="Редактиране на блок"
      mutationMode="pessimistic"
      transform={({ residentialNumber, houseManagerEmployeeId }) => ({ residentialNumber, houseManagerEmployeeId })}
      actions={<BackButtonToolbar />}
    >
      <SimpleForm toolbar={<InactiveDeleteOptionEditToolbar />}>
        <SaveForm />
      </SimpleForm>
    </Edit>
  );
};
export default EditBuilding;
